import { render, staticRenderFns } from "./group_activity.vue?vue&type=template&id=2e28252b&scoped=true"
import script from "./group_activity.vue?vue&type=script&lang=js"
export * from "./group_activity.vue?vue&type=script&lang=js"
import style0 from "./group_activity.vue?vue&type=style&index=0&id=2e28252b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e28252b",
  null
  
)

export default component.exports